import type { NodeRenderer } from '../generateNodes';
import type { ParagraphNode } from '../schema';
import styles from './renderers.module.css';

export const ParagraphRenderer: { paragraph: NodeRenderer<ParagraphNode> } = {
  paragraph: ({ node, nodesToJSX }) => (
    <p className={styles.paragraph}>{nodesToJSX({ nodes: node.children })}</p>
  ),
};
